import styled from 'styled-components'

const DeleteAtom = styled.div`
  margin-left: 10px;
  cursor: pointer;
`
export { DeleteAtom }
